// utils/axios.js
import axios from "axios";
import store from "@/store";
import { CONFIG } from "@/constants/config";

// Create Axios instance
const api = axios.create({
  baseURL: CONFIG.BACKEND_URL,
});

// REQUEST INTERCEPTOR — set default notification flags
api.interceptors.request.use((config) => {
  config.successNotify = config.successNotify === true;
  config.errorNotify = config.errorNotify !== false;
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// RESPONSE INTERCEPTOR
api.interceptors.response.use(
  (response) => {
    if (response.config.successNotify) {
      const message =
        response.config.successMessage ||
        response.data?.message ||
        "Operation successful";

      // Dispatch to Vuex notification store
      store.dispatch("notification/addNotification", {
        type: "success",
        message,
      });
    }

    return response;
  },
  (error) => {
    const config = error.config || {};
    if (config.errorNotify) {
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Something went wrong";
      console.log(message);
      // Dispatch error to Vuex notification store
      store.dispatch("notification/addNotification", {
        type: "error",
        message,
      });
    }

    return Promise.reject(error);
  }
);

export default api;
